export const isScreenSmall = () => screen.width <= 800;
